/* eslint-disable */
import { useContext, useEffect, useState } from 'react';
import { Input } from '@acko-tech/building-blocks.ui.input';
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import { NewPlanStages } from '../constants';
import {
    SegmentEventNameTypes,
    SegmentEventActionTypes,
    SegmentEventActionNames,
    SegmentEventPages,
    SegmentEventPageTypes,
} from 'utils/segment/constants';
import { MPosContext } from 'utils/context';
import Calendar from '@acko-tech/building-blocks.ui.calendar';
import { useResponsiveDevice } from 'hooks/useResponsiveDevice';
import SnackBar from 'library/snackbar';
import * as Styles from './styles';
import { isEmpty, getImageBasePath, isAnyKeyEmpty } from 'utils/generics';
import { ModalMobile } from '@acko-tech/building-blocks.ui.modal';
import Image from 'next/image';
import {getDayMonthYear, getFieldActionName} from './utils';
import sendSegmentEvent from 'utils/segment';

function VehicleDetails() {
    const {
        planDetails,
        setPlanDetails,
        setActiveStage,
        userDetails,
    } = useContext(MPosContext);

    const [showCalendarModal, setShowCalendarModal] = useState(false);
    const [isContinueButtonDisabled, setIsContinueButtonDisabled] =
        useState(true);
    const [snackbar, setSnackbar] = useState({
        type: '',
        message: '',
    });
    const [validationErr, setValidationErr] = useState({
        vin: '',
        bin: '',
        bin2: '',
        rto: '',
        registration_number: '',
        motor_number: '',
        charger_number: '',
    });
    const { isMobile } = useResponsiveDevice();
    const [onClickSerialNumber, setOnClickSerialNumber] = useState(false);
    const [onClickConfirmSerialNumber, setOnClickConfirmSerialNumber] =
        useState(false);
    const [formData, setFormData] = useState({
        rto: planDetails.device.rto_code,
        vin: planDetails.device.vin_number,
        bin: planDetails.device.bin_number,
        bin2: planDetails.device.bin2_number,
        registration_number: planDetails.device.registration_number,
        invoice_date: planDetails.device.invoice_date,
        motor_number: planDetails.device.motor_number,
        charger_number: planDetails.device.charger_number,
    });

    useEffect(() => {
        sendSegmentEvent(
            SegmentEventNameTypes.VIEW,
            {
                page_type: SegmentEventPageTypes.VEHICLE_DETAILS_PAGE,
                view_name: SegmentEventPages.VIEW_VEHICLE_DETAILS_PAGE,
            },
            { userDetails, isMobile }
        );
    }, [window]);

    function validator() {
        return {
            motor_number: () => {
                setValidationErr({
                    ...validationErr,
                    motor_number: '',
                });
            },

            charger_number: () => {
                setValidationErr({
                    ...validationErr,
                    charger_number: '',
                });
            },
            rto: (val) => {
                if (!/^[A-Za-z]{2}[0-9]{2}$/i.test(val))
                    setValidationErr({
                        ...validationErr,
                        rto: 'Please enter valid rto',
                    });
                else setValidationErr({ ...validationErr, rto: '' });
            },
            vin: (val) => {
                if (!/^[a-zA-Z0-9]{17}$/.test(val))
                    setValidationErr({
                        ...validationErr,
                        vin: 'Please enter valid VIN',
                    });
                else setValidationErr({ ...validationErr, vin: '' });
            },
            bin: (val) => {
                if (!/^[a-zA-Z0-9]{12,16}$/.test(val))
                    setValidationErr({
                        ...validationErr,
                        bin: 'Please enter valid BIN',
                    });
                else setValidationErr({ ...validationErr, bin: '' });
            },
            bin2: () => {
                setValidationErr({
                    ...validationErr,
                    bin2: '',
                });
            },
            registration_number: (val) => {
                const registrationNumberRegex = [
                    '^[A-Z][A-Z][0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$',
                    '^[A-Z][A-Z][0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$',
                    '^[A-Z][A-Z][A-Z][0-9][0-9][0-9][0-9]$',
                    '^[A-Z][A-Z][0-9][0-9][A-Z][A-Z][A-Z][0-9][0-9][0-9][0-9]$',
                    '^[A-Z][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$',
                    '^[A-Z][A-Z][0-9][0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$',
                    '^[A-Z][A-Z][0-9][0-9][0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$',
                    '^[A-Z][A-Z][0-9][0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$',
                    '^[A-Z][A-Z][0-9][0-9][A-Z][1-9][0-9][0-9][0-9][0-9]$',
                    '^[A-Z][A-Z][0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9][0-9]$',
                    '^[A-Z][A-Z][0-9][0-9][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$',
                    '^(GJ|DL|BR)[0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$',
                    '^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9]$',
                    '^(GJ|DL|BR)[0-9][A-Z][A-Z][A-Z][0-9][0-9][0-9][0-9]$',
                    '^(GJ|DL|BR)[0-9][0-9][0-9][0-9][0-9]$',
                    '^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9][0-9]$',
                    '^(GJ|DL|BR)[0-9][A-Z][A-Z][0-9][0-9][0-9][0-9][0-9]$',
                    '^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$',
                    '^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$',
                    '^[0-9][0-9][A-Z][A-Z][0-9][0-9]$',
                    '^[0-9][0-9][A-Z][A-Z][0-9][0-9][0-9]$',
                    '^[0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$',
                    '^[0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$',
                    '^[0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9][A-Z]$',
                    '^[0-9][0-9][X][X][0-9][0-9][0-9][0-9][A-Z][A-Z]$',
                ];
                let isValid = false;

                for (let i = 0; i < registrationNumberRegex.length; i++) {
                    const regex = new RegExp(registrationNumberRegex[i], 'i');
                    const isRegNumberValid = regex.test(val);

                    if (isRegNumberValid) {
                        isValid = true;
                    }
                }
                if (val && !isValid) {
                    setValidationErr({
                        ...validationErr,
                        registration_number:
                            'Please enter valid registration number',
                    });
                } else {
                    setValidationErr({
                        ...validationErr,
                        registration_number: '',
                    });
                }
            },
        };
    }
    useEffect(() => {
        if (
            isEmpty(validationErr) &&
            !isAnyKeyEmpty({
                ...formData,
                registration_number: 'dummy',
                charger_number: 'dummy',
                motor_number: 'dummy',
                bin2: 'dummy',
            })
        ) {
            setIsContinueButtonDisabled(false);
        } else {
            setIsContinueButtonDisabled(true);
        }
    }, [formData]);

    function formHandler(e, name) {
        const { value } = e.target;
        validator()?.[name](value);
        setFormData({ ...formData, [name]: value });
    }

    useEffect(() => {
        if (onClickSerialNumber) {
            /**
             * Segment event
             */
            sendSegmentEvent(
                SegmentEventNameTypes.ACTION,
                {
                    action_type: SegmentEventActionTypes.ENTER_TEXT,
                    action_name: SegmentEventActionNames.ENTER_VIN_NUMBER,
                },
                { userDetails, isMobile }
            );
        }
    }, [onClickSerialNumber]);

    useEffect(() => {
        if (onClickConfirmSerialNumber) {
            /**
             * Segment event
             */
        sendSegmentEvent(
            SegmentEventNameTypes.ACTION,
            {
                action_type: SegmentEventActionTypes.ENTER_TEXT,
                action_name: SegmentEventActionNames.CLICK_BIN_NUMBER,
            },
            { userDetails, isMobile }
        );
        }
    }, [onClickConfirmSerialNumber]);

    const onSubmit = () => {
        setPlanDetails({
            ...planDetails,
            device: {
                ...planDetails.device,
                vin_number: formData.vin,
                bin_number: formData.bin,
                bin2_number: formData.bin2,
                registration_number: formData.registration_number,
                rto_code: formData.rto,
                invoice_date: formData.invoice_date,
                motor_number: formData.motor_number,
                charger_number: formData.charger_number,
            },
        });
        setActiveStage(NewPlanStages.USER_DETAILS);
         /**
             * Segment event
             */
         sendSegmentEvent(
            SegmentEventNameTypes.ACTION,
            {
                action_type: SegmentEventActionTypes.TAP_BTN,
                action_name: SegmentEventActionNames.CLICK_CONTINUE_VEHICLE_DETAILS,
            },
            { userDetails, isMobile }
        );
    };

    const onFieldClick = (fieldName: string) => {
        const actionName = getFieldActionName(fieldName);
        sendSegmentEvent(
            SegmentEventNameTypes.ACTION,
            {
                action_type: SegmentEventActionTypes.ENTER_TEXT,
                action_name: actionName,
            },
            { userDetails, isMobile }
        );
    };

    const onInvoiceDateClick = () => {
         setShowCalendarModal(true);
         onFieldClick('invoice_date');
    };
    
    const onDateSelect = (d) => {
        setFormData({ ...formData, invoice_date: d.toISOString() });
    };

    return (
        <Styles.Wrapper
            style={{ position: 'relative', height: '100%', minHeight: '580px' }}
        >
            <Styles.ScanIMEINumber>
                {'Enter your vehicle details'}
            </Styles.ScanIMEINumber>
            <Styles.InputWrapper onClick={onInvoiceDateClick}>
                <Input
                    className={''}
                    labelText={'Date of vehicle Invoice'}
                    name={'date'}
                    type={'text'}
                    value={getDayMonthYear(formData?.invoice_date)}
                    onChange={(e) => formHandler(e, 'invoice_date')}
                    rightElement={
                        <Image
                            src={getImageBasePath('/icons/calendar.svg')}
                            width={24}
                            height={24}
                        />
                    }
                >
                    <Image
                        width={'11px'}
                        height={'16px'}
                        alt={''}
                        src={getImageBasePath('/icons/bike.svg')}
                    />
                </Input>
            </Styles.InputWrapper>
            <Styles.InputWrapper onClick={() => setOnClickSerialNumber(true)}>
                <Input
                    className={''}
                    labelText={'VIN Number'}
                    name={'vin'}
                    type={'text'}
                    value={formData.vin}
                    onChange={(e) => formHandler(e, 'vin')}
                    errMsg={validationErr.vin}
                    hasError={validationErr.vin.length > 0}
                />
            </Styles.InputWrapper>
            <Styles.InputWrapper
                onClick={() => setOnClickConfirmSerialNumber(true)}
            >
                <Input
                    className={''}
                    labelText={'BIN Number'}
                    name={'bin'}
                    type={'text'}
                    value={formData.bin}
                    onChange={(e) => formHandler(e, 'bin')}
                    errMsg={validationErr.bin}
                    hasError={validationErr.bin.length > 0}
                />
            </Styles.InputWrapper>
            <Styles.InputWrapper onClick={() => onFieldClick('bin2')}>
                <Input
                    className={''}
                    labelText={`BIN2 Number (Optional)`}
                    name={'bin2_number'}
                    type={'text'}
                    value={formData.bin2}
                    onChange={(e) => formHandler(e, 'bin2')}
                    errMsg={validationErr.bin2}
                    hasError={validationErr.bin2.length > 0}
                />
            </Styles.InputWrapper>
            <Styles.InputWrapper onClick={() => onFieldClick('registration_number')}>
                <Input
                    className={''}
                    labelText={`Registration number (Optional)`}
                    name={'registration_number'}
                    type={'text'}
                    value={formData.registration_number}
                    onChange={(e) => formHandler(e, 'registration_number')}
                    errMsg={validationErr.registration_number}
                    hasError={validationErr.registration_number.length > 0}
                />
            </Styles.InputWrapper>
            <Styles.InputWrapper onClick={() => onFieldClick('rto')}>
                <Input
                    className={''}
                    labelText={`RTO Code`}
                    name={'rto'}
                    type={'text'}
                    value={formData.rto}
                    onChange={(e) => formHandler(e, 'rto')}
                    errMsg={validationErr.rto}
                    hasError={validationErr.rto.length > 0}
                />
            </Styles.InputWrapper>
            <Styles.InputWrapper onClick={() => onFieldClick('motor_number')}>
                <Input
                    className={''}
                    labelText={`Motor Number (Optional)`}
                    name={'motor_number'}
                    type={'text'}
                    value={formData.motor_number}
                    onChange={(e) => formHandler(e, 'motor_number')}
                    errMsg={validationErr.motor_number}
                    hasError={validationErr.motor_number.length > 0}
                />
            </Styles.InputWrapper>
            <Styles.InputWrapper onClick={() => onFieldClick('charger_number')}>
                <Input
                    className={''}
                    labelText={`Charger Number (Optional)`}
                    name={'charger_number'}
                    type={'text'}
                    value={formData.charger_number}
                    onChange={(e) => formHandler(e, 'charger_number')}
                    errMsg={validationErr.charger_number}
                    hasError={validationErr.charger_number.length > 0}
                />
            </Styles.InputWrapper>
            <Styles.ButtonWrapper
                style={{
                    width: '100%',
                    margin: '10px 0',
                }}
            >
                <PrimaryButton
                    disabled={isContinueButtonDisabled}
                    onClick={onSubmit}
                >
                    Continue
                </PrimaryButton>
            </Styles.ButtonWrapper>
            <SnackBar
                {...snackbar}
                handleSnakbarComplete={() =>
                    setSnackbar({ type: '', message: '' })
                }
            />
            <ModalMobile
                header={<></>}
                urlhash={''}
                show={showCalendarModal}
                onHide={() => setShowCalendarModal(false)}
                padding={'20px'}
                showOverlayBackground={true}
            >
                <Calendar
                    title=""
                    defaultDate={
                        formData.invoice_date
                            ? new Date(formData.invoice_date)
                            : new Date()
                    }
                    onSelect={(date) => {
                        setShowCalendarModal(false), onDateSelect(date);
                    }}
                    enableWindow={{
                        start: new Date(
                            new Date().setFullYear(
                                new Date().getFullYear() - 100
                            )
                        ),
                        current: new Date(),
                        end: new Date(),
                    }}
                    isDesktop={false}
                />
            </ModalMobile>
        </Styles.Wrapper>
    );
}

export default VehicleDetails;
